/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { PowSolution } from './PowSolution';
const CreatePendingRegistrationDataParser = 
/* #__PURE__ */ parsers.object([
    ['email', codecString],
    ['pow', PowSolution],
    [
        'privacyPolicyAccepted',
        /* #__PURE__ */ parsers.exactly(true),
        'privacy_policy_accepted',
    ],
]);
export class CreatePendingRegistrationData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreatePendingRegistrationDataParser.decode(input).map(res => new CreatePendingRegistrationData(res));
    }
    static unsafeDecode(input) {
        return CreatePendingRegistrationData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreatePendingRegistrationDataParser.encode(data);
    }
    static schema() {
        return CreatePendingRegistrationDataParser.schema();
    }
}
